// extracted by mini-css-extract-plugin
export default {"title":"TypeTask_title__N8jt4"};